import { render, staticRenderFns } from "./CompetitionPreviewPanel.vue?vue&type=template&id=28d0731e&scoped=true"
import script from "./CompetitionPreviewPanel.vue?vue&type=script&lang=js"
export * from "./CompetitionPreviewPanel.vue?vue&type=script&lang=js"
import style0 from "./CompetitionPreviewPanel.vue?vue&type=style&index=0&id=28d0731e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d0731e",
  null
  
)

export default component.exports